import { CheckCheckIcon, Loader2, LucideCamera } from "lucide-react";
import { useCallback, useState } from "react";
import { Button, cn } from "web-design-system";

export function SnapshotButton(props: {
  className?: string;
  onSnapshot: () => Promise<void>;
}) {
  const { onSnapshot } = props;

  const [uiState, setUiState] = useState<"ready" | "busy" | "waiting">("ready");

  const handleClick = useCallback(async () => {
    try {
      setUiState("busy");
      await onSnapshot();
      setUiState("waiting");
    } finally {
      setTimeout(() => {
        setUiState("ready");
      }, 2000);
    }
  }, [onSnapshot]);

  return (
    <Button
      variant="outline"
      size="sm"
      className={cn(
        "opacity-100 absolute duration-200 right-0 top-2",
        props.className
      )}
      disabled={uiState !== "ready"}
      onClick={handleClick}
      data-html2canvas-ignore
    >
      {uiState === "busy" && (
        <>
          <Loader2 className="animate-spin" />
          Taking snapshot...
        </>
      )}
      {uiState === "waiting" && (
        <>
          <CheckCheckIcon />
          Take snapshot
        </>
      )}
      {uiState === "ready" && (
        <>
          <LucideCamera />
          Take snapshot
        </>
      )}
    </Button>
  );
}
